import { styled } from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";

export const Wrapper = styled.div``;

export const AddonDisplayTitile = styled(Text)`
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: #040222;

  @media (min-width: 768px) {
    font-size: 16px;
    line-height: 24px;
  }
`;

export const AddonDescription = styled(Text)`
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: #5b5675;
  margin-top: 8px;

  @media (min-width: 768px) {
    font-size: 14px;
    line-height: 20px;
  }
`;

export const LearnMore = styled(Text)`
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  text-decoration-line: underline;
  color: #36354c;

  :hover {
    cursor: pointer;
  }
`;

export const AddonHighlight = styled(Text)`
  font-size: 12px;
  font-weight: 450;
  line-height: 18px;
  color: #7c47e1;
  margin-top: 4px;
`;
